module.exports = __webpack_public_path__ + "static/media/wunderlist-design-clone.26d6e3c4.png";